// This file is automatically generated. Do not edit it directly.
import { createMiddleware } from "@tanstack/react-start";

// Must be registered as a global `functionMiddleware` in `src/start.ts`; otherwise
// the browser never attaches the bearer token to serverFn RPCs.
// Dynamic-import the client so supabase-js is not in the homepage JS payload.
// Also skip the import entirely when no auth storage key exists (public pages).
function hasStoredSupabaseSession(): boolean {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("sb-") && key.endsWith("-auth-token")) {
        return Boolean(localStorage.getItem(key));
      }
    }
  } catch {
    // private mode / blocked storage — treat as logged out
  }
  return false;
}

export const attachSupabaseAuth = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    if (!hasStoredSupabaseSession()) {
      return next({ headers: {} });
    }
    const { supabase } = await import("./client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  },
);
